import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const UPCOMING_CANCELLATIONS_REQUEST = 'UPCOMING_CANCELLATIONS_REQUEST';
export const UPCOMING_CANCELLATIONS_SUCCESS = 'UPCOMING_CANCELLATIONS_SUCCESS';
export const UPCOMING_CANCELLATIONS_FAILURE = 'UPCOMING_CANCELLATIONS_FAILURE';

export const UPCOMING_CANCELLATIONS_EXPORT_REQUEST = 'UPCOMING_CANCELLATIONS_EXPORT_REQUEST';
export const UPCOMING_CANCELLATIONS_EXPORT_SUCCESS = 'UPCOMING_CANCELLATIONS_EXPORT_SUCCESS';
export const UPCOMING_CANCELLATIONS_EXPORT_FAILURE = 'UPCOMING_CANCELLATIONS_EXPORT_FAILURE';

export const loadUpcomingCancellations = (options) => ({
	[CALL_API]: {
		types: [UPCOMING_CANCELLATIONS_REQUEST, UPCOMING_CANCELLATIONS_SUCCESS, UPCOMING_CANCELLATIONS_FAILURE],
		endpoint: `api/lessonPayments/upcomingCancellations`,
		request: options,
		schema: Schemas.UPCOMING_CANCELLATIONS_ARRAY
	}
});

export const exportUpcomingCancellations = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [UPCOMING_CANCELLATIONS_EXPORT_REQUEST, UPCOMING_CANCELLATIONS_EXPORT_SUCCESS, UPCOMING_CANCELLATIONS_EXPORT_FAILURE],
			endpoint: `api/lessonPayments/upcomingCancellations/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `UpcomingCancellations-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}